const LangNotFound = {
	"notFound._title": ["Doh 404!", "Doh 404!"],
	"notFound._message": [
		`Oops! Something went wrong.`,
		`អូហ៍!​​ ប្រព័ន្ធ​មិន​ដំណើរ​ការ​`,
	],
}

export default LangNotFound



// WEBPACK FOOTER //
// ./src/resources/pages/LangNotFound.js